import React, { lazy } from 'react';
import { MapPin, Clock, Phone, Mail } from 'lucide-react';
export function MapHours() {
  const hours = [{
    day: 'Monday - Thursday',
    time: '5:00 PM - 11:00 PM'
  }, {
    day: 'Friday - Saturday',
    time: '5:00 PM - 12:00 AM'
  }, {
    day: 'Sunday',
    time: '5:00 PM - 10:00 PM'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black" data-id="element-62">
      <div className="max-w-7xl mx-auto" data-id="element-63">
        <div className="text-center mb-16" data-id="element-64">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4" data-id="element-65">
            Visit Us
          </h2>
          <p className="text-xl text-gray-300" data-id="element-66">
            We look forward to welcoming you
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-67">
          {/* Map */}
          <div className="bg-slate-950 rounded-2xl overflow-hidden h-[400px] border-2 border-slate-800" data-id="element-68">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.9663095919355!2d-74.00425878459253!3d40.74076794379132!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9b3117469%3A0xd134e199a405a163!2sEmpire%20State%20Building!5e0!3m2!1sen!2sus!4v1234567890" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Kumo Izakaya location map" data-id="element-69" />
          </div>

          {/* Hours & Contact */}
          <div className="space-y-8" data-id="element-70">
            {/* Hours */}
            <div data-id="element-71">
              <div className="flex items-center gap-3 mb-6" data-id="element-72">
                <Clock className="w-6 h-6 text-amber-400" data-id="element-73" />
                <h3 className="text-2xl font-bold text-white" data-id="element-74">Hours</h3>
              </div>
              <div className="space-y-3" data-id="element-75">
                {hours.map((item, index) => <div key={index} className="flex justify-between items-center py-3 border-b border-slate-800" data-id="element-76">
                    <span className="text-gray-200 font-medium" data-id="element-77">
                      {item.day}
                    </span>
                    <span className="text-amber-400 font-semibold" data-id="element-78">
                      {item.time}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Contact */}
            <div data-id="element-79">
              <div className="flex items-center gap-3 mb-6" data-id="element-80">
                <MapPin className="w-6 h-6 text-amber-400" data-id="element-81" />
                <h3 className="text-2xl font-bold text-white" data-id="element-82">Contact</h3>
              </div>
              <div className="space-y-4" data-id="element-83">
                <div className="flex items-start gap-3" data-id="element-84">
                  <MapPin className="w-5 h-5 text-gray-300 mt-1 flex-shrink-0" data-id="element-85" />
                  <div data-id="element-86">
                    <p className="text-gray-200" data-id="element-87">123 Downtown Avenue</p>
                    <p className="text-gray-200" data-id="element-88">New York, NY 10001</p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-89">
                  <Phone className="w-5 h-5 text-gray-300 flex-shrink-0" data-id="element-90" />
                  <a href="tel:+12125551234" className="text-gray-200 hover:text-amber-400 transition-colors" data-id="element-91">
                    (212) 555-1234
                  </a>
                </div>
                <div className="flex items-center gap-3" data-id="element-92">
                  <Mail className="w-5 h-5 text-gray-300 flex-shrink-0" data-id="element-93" />
                  <a href="mailto:info@kumoizakaya.com" className="text-gray-200 hover:text-amber-400 transition-colors" data-id="element-94">
                    info@kumoizakaya.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}